import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Award, ArrowRight } from "lucide-react";

export default function Certificates() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/certificates").then(r => setList(r.data)); }, []);
  return (
    <div className="max-w-5xl mx-auto px-6 py-12" data-testid="certificates-page">
      <div className="text-xs uppercase tracking-widest text-gold-700 font-mono mb-3">Vos preuves</div>
      <h1 className="font-display text-4xl text-ink-900">Mes certificats</h1>
      <p className="text-muted2 mt-2">Tous vos certificats E.C.S, prêts à être téléchargés et partagés.</p>

      {list.length === 0 ? (
        <div className="glass rounded-2xl p-12 mt-8 text-center" data-testid="empty-certificates">
          <Award className="w-12 h-12 text-muted2 mx-auto mb-3" />
          <h3 className="font-display text-2xl text-ink-900">Aucun certificat pour l'instant</h3>
          <p className="text-muted2 text-sm mt-2">Validez votre première certification pour en débloquer un.</p>
          <Link to="/categories" className="inline-block mt-5 px-6 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400">
            Explorer les catégories
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          {list.map(c => (
            <Link key={c.id} to={`/certificates/${c.id}`} className="glass rounded-2xl p-6 hover:shadow-gold transition group" data-testid={`certificate-card-${c.unique_code}`}>
              <div className="flex items-start justify-between mb-3">
                <Award className="w-7 h-7 text-gold-700" />
                <span className="font-mono text-xs text-muted2">{c.unique_code}</span>
              </div>
              <h3 className="font-display text-xl text-ink-900 group-hover:text-gold-700-700">{c.certification_title}</h3>
              <p className="text-xs text-muted2 mt-1">{c.category_name}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-muted2">{new Date(c.issued_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>
                <ArrowRight className="w-4 h-4 text-gold-700 group-hover:translate-x-1 transition" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
